import { useMemo } from 'react';

import { Button } from '@components';
import styles from './BuildCustomization.module.scss';

export default function QuoteButton({ clicked, locale, formMode, addOnsEnabled }) {
  const text = useMemo(() => {
    switch (formMode) {
      case 'configuration':
        return locale == 'fr' ? 'Compléments Kubota' : 'Kubota Add-Ons';
        break;
      case 'customize':
        return locale == 'fr' ? (
          addOnsEnabled ? 'Compléments Land Pride' : 'Sommaire'
        ) : (
          addOnsEnabled ? 'Land Pride Add-Ons' : 'Summary'
        );
        break;
      case 'addOns':
        return locale == 'fr' ? 'Sommaire' : 'Summary';
        break;
      case 'summary':
        return locale == 'fr' ? 'Envoyer le devis au concessionnaire' : 'Send Quote To Dealer';
        break;
      default:
        return locale == 'fr' ? 'Sommaire' : 'Summary';
        break;
    }
  }, [formMode, locale]);

  return (
    <Button
      className={styles.continueBtn}
      onClick={clicked}
    >
      {text}
    </Button>
  );
}
